import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c2a5b97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]

import { useRoute } from "vue-router";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    name: {}
  },
  setup(__props: any) {

const route = useRoute();

const props = __props;

const source = ref<string>("");

const name = ref<string>();

source.value = `https://img.pptutor.com/pptutor/activity/${props.name}.jpg`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: source.value,
      alt: ""
    }, null, 8, _hoisted_2)
  ]))
}
}

})